import { ITypedReduxAction } from '../../../types/redux/actionType';

export enum EResetPostActionType {
  Reset = 'post/resetPost',
}

export type TResetPost = ITypedReduxAction<EResetPostActionType.Reset>;
